import { Injectable } from '@angular/core';

@Injectable()

export class SessionHelper {
    static IS_LOGGED_IN: string = "IsLoggedIn";
    static USER: string = "User";
    constructor() { }
  
    static isLoggedIn = () => { return JSON.parse(localStorage.getItem(SessionHelper.IS_LOGGED_IN)) || false; }

    static getSession = () => {
        if (SessionHelper.isLoggedIn()) {
            return JSON.parse(localStorage.getItem(SessionHelper.USER));
        }
        return null;
    }

    static setSession(data: any) {
        localStorage.setItem(SessionHelper.USER, JSON.stringify(data));
        localStorage.setItem(SessionHelper.IS_LOGGED_IN, JSON.stringify(true))
    }

    static getBrands() {
        if (SessionHelper.isLoggedIn()) {
            let user = JSON.parse(localStorage.getItem(SessionHelper.USER));
            if (user !== undefined) {
                return user.UserCompanyBrandMapping;
            }
        }
        return null;
    }

    static logout = () => {
        localStorage.clear();
    }
}